import { Dom7 as $ } from "framework7/bundle";
import { api, ok } from "./api.js";
import { writeItem } from "./storage.js";
import { clearSession } from "./session.js";
import { localizeStr } from "./i18n.js";
import { setTheme } from "./ui.js";

// Zwischenstand des Logins ueber die Seiten E-Mail/Passwort -> PIN hinweg.
let username = "";
let password = "";
let pincode = "";
let invitationCode = "";

let app = null;

function navigate(path) {
    app.views.main.router.navigate(path, { animate: false });
}

export function login() {
    api.post("/frontend/patient/login", { email: username, password, pincode })
        .then(function (res) {
            const resData = res.data;
            if (!ok(resData)) throw new Error("login failed");

            writeItem("bearer", resData.data.token, "cookie");
            writeItem("is_loggedin", "1", "cookie");
            writeItem("first_name", resData.data.patient.first_name, "localStorage");
            writeItem("last_name", resData.data.patient.last_name, "localStorage");
            writeItem("settings", JSON.stringify(resData.data.settings), "localStorage");

            const ps = resData.data.patient.patient_settings;
            if (ps.length > 0 && ps[0].system_theme !== null) {
                writeItem("theme_class", ps[0].system_theme.css_class, "localStorage");
            } else {
                writeItem("theme_class", "", "localStorage");
            }

            setTheme();

            // OneSignal-Registrierung in der Median-App
            if (window.median) window.median_library_ready();

            navigate("/dashboard/");
        })
        .catch(function () {
            app.dialog.alert(localizeStr("error_login_message_failed"), localizeStr("error_login_title"), function () {
                navigate("/onboarding/login/");
            });
        });
}

export function logout() {
    api.post("/frontend/patient/logout").catch(() => {});
    clearSession();
    app.views.main.router.navigate("/onboarding/welcome/", { reloadAll: true });
}

export function verifyInvitationCode() {
    const failed = () => {
        app.dialog.alert(localizeStr("error_invitation_message_failed"), localizeStr("error_invitation_title"), function () {
            $(".pininput-invitation").val("");
        });
    };

    api.post("/frontend/patient/invitation", { invitation_code: invitationCode })
        .then(function (res) {
            if (!ok(res.data)) return failed();
            writeItem("invitation_code", invitationCode, "cookie");
            navigate("/onboarding/createaccountAGB/");
        })
        .catch(failed);
}

export function verifyResetCode(code) {
    const email = $("#pwresetFrmEmail").val();
    api.post("/frontend/patient/checkresetcode", { code, email })
        .then(function (res) {
            const resData = res.data;
            if (ok(resData)) {
                writeItem("reset_code", code, "cookie");
                writeItem("email", email, "cookie");
                navigate("/onboarding/resetpw/setpassword/");
            } else if (String(resData.status_code) === "10") {
                app.dialog.alert(localizeStr("error_resetcode_expired_message"), localizeStr("error_resetcode_title"), function () {
                    navigate("/onboarding/resetpw/");
                });
            } else {
                app.dialog.alert(localizeStr("error_resetcode_wrong_message"), localizeStr("error_resetcode_title"), function () {
                    $(".pininput-pwreset").val("");
                });
            }
        });
}

/** Cursor ins naechste PIN-Feld, wenn das aktuelle gefuellt ist. */
function advancePin(input, event) {
    if (event.keyCode === 9 || event.shiftKey) return;
    const el = $(input);
    if (el.val() === "") return;
    el.removeClass("is-invalid");
    const next = el.attr("data-next");
    if (next) $("#" + next).focus();
}

/** Werte der Felder mit Praefix (z. B. pincodeFrmPin) 1..n; null, wenn eines leer ist. */
function collectPin(prefix, count) {
    let code = "";
    for (let i = 1; i <= count; i++) {
        const v = $("#" + prefix + i).val();
        if (v === "") return null;
        code += v;
    }
    return code;
}

/**
 * Handler fuer Login- und PIN-Seiten. Wird bei jedem pageInit gebunden; die
 * Selektoren treffen nur auf der jeweiligen Seite, und deren Elemente sind
 * bei jedem Aufruf neu - es sammeln sich also keine Handler an.
 */
export function installAuthHandlers(f7) {
    app = f7;

    app.on("pageInit", function () {
        $("#loginBtnLogin").on("click", function () {
            username = $("#loginFrmEmail").val();
            password = $("#loginFrmPassword").val();

            if (username === "" || password === "") {
                app.dialog.alert(localizeStr("error_login_message_missing_email_password"), localizeStr("error_login_title"));
            } else {
                navigate("/onboarding/pincode/");
            }
        });

        $(".pininput").on("keyup", function (event) {
            const code = collectPin("pincodeFrmPin", 4);
            if (code !== null) {
                pincode = code;
                login();
            } else {
                advancePin(this, event);
            }
        });

        $(".pininput-invitation").on("keyup", function (event) {
            const code = collectPin("invitationFrmPin", 8);
            if (code !== null) {
                invitationCode = code;
                verifyInvitationCode();
            } else {
                advancePin(this, event);
            }
        });

        $(".pininput-pwreset").on("keyup", function (event) {
            const code = collectPin("pwresetFrmPin", 6);
            if (code !== null) {
                verifyResetCode(code);
            } else {
                advancePin(this, event);
            }
        });
    });
}

/** Profilbild des Patienten, sonst Platzhalter. */
export function readProfilePicture() {
    const fallback = "/assets/images/temp/avatar.jpg";
    return api
        .get("/frontend/patient/avatar")
        .then((res) => (ok(res.data) ? res.data.data.file : fallback))
        .catch(() => fallback);
}
